<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="part1"> </p>
<p class="PN"><span href="#/xhtml/contents#c_part1" title="Link target outside of Sample">PART ONE</span></p>
<p class="PT"><span href="#/xhtml/contents#c_part1" title="Link target outside of Sample">FRESH AIR … A LUCKY BREAK</span></p>
<p class="PEP"><span class="ePub-I">I knew that I wanted to be someone.… I wanted to be revered by the family … not only by my immediate one, but my extended family as well.… They all were so excited when I finished medical school that they had this large party for me. I still have the pictures. Actually, it spawned many other doctors in the family whose fathers said to them, “Forget about being a wallpaper hanger. If Mickey could do it, then you could do it!”</span></p>
<p class="PEPC">—M<span class="ePub-SC">ICHAEL</span> (“M<span class="ePub-SC">ICKEY</span>”) B<span class="ePub-SC">RESCIA</span>, M.D.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?636ea5a4